import { Fragment } from 'react';
import { Button, BUTTON } from 'components/common/Button/Button';
import { SpinnerMini } from 'components/common/LoadingStatus/LoadingStatus';
import styles from './styles.scss';

export default function Footer({handleNext, handleCancel, isStep, handleSaveAsDraft, handleSubmit, handlePrevious, submittingAction}) {
    return (
        <Fragment>
            {
                isStep === 'one' && (
                    <StepOne onCancel={handleCancel} onNext={handleNext}/>
                )
            }
            {
                isStep === 'two' && (
                    <StepTwo onCancel={handleCancel} onPrevious={handlePrevious} onDraft={handleSaveAsDraft} handleSubmit={handleSubmit} submittingAction={submittingAction} />
                )
            }
        </Fragment>
    );
}

function StepOne({onCancel, onNext}) {
    return (
        <div className={styles.Footer}>
            <Button
                bgcolor={BUTTON.BGCOLOR.WHITE}
                type={BUTTON.SIZE.SECONDARY}
                color={BUTTON.COLOR.BLACK}
                outline={BUTTON.OUTCOLOR.LIGHTGREY}
                onClick={onCancel}
            >
                Cancel
            </Button>

            <Button
                type={BUTTON.SIZE.SECONDARY}
                bgcolor={BUTTON.BGCOLOR.ORANGE}
                color={BUTTON.COLOR.WHITE}
                onClick={onNext}
            >
                Next
            </Button>
        </div>
    );
}

function StepTwo({onCancel, handleSubmit, onPrevious, onDraft, submittingAction}) {
    const isSubmitting = !!submittingAction;
    const isFinishing = submittingAction === 'submit';
    const isDrafting = submittingAction === 'draft';

    return (
        <div className={styles.Footer}>
            <div className={styles.FooterInnerItem}>
                <Button
                    bgcolor={BUTTON.BGCOLOR.WHITE}
                    type={BUTTON.SIZE.SECONDARY}
                    color={BUTTON.COLOR.BLACK}
                    outline={BUTTON.OUTCOLOR.LIGHTGREY}
                    onClick={onCancel}
                    disabled={isSubmitting}
                >
                    Cancel
                </Button>

                <Button
                    bgcolor={isDrafting ? BUTTON.BGCOLOR.GREY7 : BUTTON.BGCOLOR.WHITE}
                    type={BUTTON.SIZE.SECONDARY}
                    color={isDrafting ? BUTTON.COLOR.WHITE : BUTTON.COLOR.BLACK}
                    outline={isDrafting ? BUTTON.OUTCOLOR.NONE : BUTTON.OUTCOLOR.LIGHTGREY}
                    onClick={onDraft}
                    disabled={isSubmitting}
                >
                    {isDrafting ?
                        <div className={styles.buttonSpinner}>
                            <SpinnerMini />
                        </div> :
                        'Save Draft'}
                </Button>
            </div>

            <div className={styles.FooterInnerItem}>
                <Button
                    bgcolor={BUTTON.BGCOLOR.WHITE}
                    type={BUTTON.SIZE.SECONDARY}
                    color={BUTTON.COLOR.BLACK}
                    outline={BUTTON.OUTCOLOR.LIGHTGREY}
                    onClick={onPrevious}
                    disabled={isSubmitting}
                >
                    Previous
                </Button>

                <Button
                    type={BUTTON.SIZE.SECONDARY}
                    bgcolor={isFinishing ? BUTTON.BGCOLOR.GREY7 : BUTTON.BGCOLOR.ORANGE}
                    color={BUTTON.COLOR.WHITE}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                >
                    {isFinishing ?
                        <div className={styles.buttonSpinner}>
                            <SpinnerMini />
                        </div> :
                        'Finish'}
                </Button>
            </div>
        </div>
    );
}